import * as React from 'react';

import { translate } from '~l10n/client';
import { Decimal128 } from 'proposal-decimal';

import { formatPrice } from '~teacher/components/PricingTable/PriceComponent/helpers';

interface MonthSeatPriceProps {
  price: Decimal128;
}

export function MonthSeatPrice({ price }: MonthSeatPriceProps) {
  return (
    <div
      className="font-sans text-base leading-12"
      dangerouslySetInnerHTML={{
        __html: translate('{0} Per Seat/Month').format(
          `<span class="font-display text-lg font-700">${formatPrice(
            price
          )}</span>`
        ),
      }}
    />
  );
}
